module.exports = __webpack_public_path__ + "static/logo-dark-e6a41d54cf34b949c1391f1eb0874d64.svg";